import {
  RouteCondition,
  ContentTypeCondition,
} from '@plone/volto/helpers/Slots';

import { FerraraTerraEAcquaBlocks } from './config/blocks';
import { FerraraTerraEAcquaGdpr } from './config/gdpr';

import NewsletterButtons from './components/NewsletterButtons/NewsletterButtons';
import FTASummaryInfos from './components/Views/Itinerary/FTASummaryInfo';
import favicon from './static/favicon.ico';
import iconSvg from './static/icon.svg';
import appleTouchIcon from './static/apple-touch-icon.png';

import DataGridWidget from './components/Widgets/DataGridWidget';
import TextWidget from './components/Widgets/TextWidget';
import GlobalAppExtras from './components/GlobalAppExtras/GlobalAppExtras';

const applyConfig = (config) => {
  config.settings.iovisit.siteName = 'Ferrara Terra e Acqua';
  config.settings.iovisit.eventsCitiesVocabulary =
    'iovisit.ferraraterraeacqua.cities';
  config.settings.isMultilingual = true;
  config.settings.supportedLanguages = [
    'it',
    'en',
    // 'es',
    // 'fr',
    // 'de',
    // 'da',
    // 'zh-cn',
    // 'ru',
    // 'nl',
  ];
  config.settings.defaultLanguage = 'it';

  config.settings.iovisit.topLink = {
    text: 'Sito ufficiale di informazione turistica della provincia di Ferrara',
    url: '',
  };

  config.registerSlotComponent({
    slot: 'aboveContent',
    name: 'newsletter-buttons',
    component: NewsletterButtons,
    predicates: [RouteCondition('/it/mailchimp/**')],
  });

  config.registerSlotComponent({
    slot: 'leadimage-more',
    name: 'itinerary-infos',
    component: FTASummaryInfos,
    predicates: [ContentTypeCondition(['Itinerary'])],
  });

  config.settings.iovisit.favicon = [
    { rel: 'icon', sizes: 'any', href: favicon },
    { rel: 'icon', sizes: 'any', href: iconSvg },
    { rel: 'icon', sizes: 'any', href: appleTouchIcon },
  ];

  config.widgets.widget.data_grid = DataGridWidget;
  config.widgets.default = TextWidget;

  FerraraTerraEAcquaBlocks(config);
  FerraraTerraEAcquaGdpr(config);

  config.settings.appExtras = [
    ...config.settings.appExtras,

    {
      match: '',
      component: GlobalAppExtras,
    },
  ];

  return config;
};

export default applyConfig;
